<template>
  <div id="reporte_proximo_periodo">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col xs="12">
          <base-material-card color="primary" icon="library_books" title="PERIODOS OMITIDOS"
            class="elevation-1 px-5 py-3">

            <div class="contenedor-tab-reportes">

              <v-card-text>
                <v-card-title>
                  <span class="headline"></span>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-row row wrap>
                    <v-col cols="12" sm="3" md="3" lg="3">
                      <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false"
                        transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha De" color="secondary"
                            prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)"
                            v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                        </template>

                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx"
                          @input="menu1 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu1 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3">
                      <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false"
                        transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha A" color="secondary"
                            prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'"
                            :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                        </template>

                        <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx"
                          @input="menu2 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu2 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <!-- <v-col sm="3" md="2" lg="2">
                              <v-autocomplete v-model="model.ejercicio" :items="ejercicios" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Ejercicio"  :rules="[]">
                              </v-autocomplete>
                        </v-col> -->
                    <!-- <v-col sm="3" md="2" lg="2">
                              <v-autocomplete v-model="model.periodo" :items="periodos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Periodo"  :rules="[]">
                              </v-autocomplete>
                        </v-col> -->
                    <v-col sm="3" md="2" lg="2">
                      <v-autocomplete v-model="model.clave" :items="destinos" :hide-no-data="true"
                        :return-object="false" item-text="text" item-value="id" label="Clave" :rules="[]">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row style="text-align: right;">
                    <v-col>
                      <v-spacer></v-spacer>
                      <v-btn small color="info" @click="cargar_consulta();">Consultar</v-btn>
                      <v-btn v-if="datos.length > 0" color="green" @click="exportar('xlsx')" small>
                        <v-icon>mdi-file</v-icon>Excel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>

                <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options"
                  class="elevation-1 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="ejercicio" slot-scope="props">
                    <div style="text-align:center"><v-chip small
                        :color="props.row.conteo_descargos > 0 ? 'warning' : 'error'">{{ props.row.ejercicio }}</v-chip></div>
                  </template>

                  <template slot="periodo" slot-scope="props">
                    <div style="text-align:center"><v-chip small
                        :color="props.row.conteo_descargos > 0 ? 'warning' : 'error'">{{ props.row.periodo }}</v-chip></div>
                  </template>

                  <template slot="clave" slot-scope="props">
                    <div style="text-align:center">{{ props.row.clave }}</div>
                  </template>

                  <template slot="conteo_pedimentos" slot-scope="props">
                    <div style="text-align:center">{{ props.row.conteo_pedimentos }}</div>
                  </template>

                  <template slot="conteo_descargos" slot-scope="props">
                    <div style="text-align:center">{{ props.row.conteo_descargos }}</div>
                  </template>

                  <template slot="folio" slot-scope="props">
                    <div style="text-align:center">{{ props.row.folio }}</div>
                  </template>

                  <template slot="fecha_recepcion" slot-scope="props">
                    <div style="text-align:center">{{ parseDate(props.row.fecha_recepcion) }}</div>
                  </template>
                  <template slot="fecha_validacion" slot-scope="props">
                    <div style="text-align:center">{{ parseDate(props.row.fecha_validacion) }}</div>
                  </template>
                  <template slot="pedimentos_faltantes" slot-scope="props">
                    <div v-if="props.row.pedimentos_faltantes != undefined" style="text-align:center"
                      @click="row_selected = props.row; abrir_faltantes(props.row.pedimentos_faltantes)"><v-btn x-small
                        color="red" title="Ver Pedimentos Faltantes" v-tippy>{{ props.row.pedimentos_faltantes.length
                        }}</v-btn></div>
                  </template>
                  <template slot="verificado" slot-scope="props">
                    <div style="display: flex; justify-content: center;">
                      <v-checkbox v-model="props.row.validado" color="success"
                        @change="row_verificar = props.row; modal_verificar = true; motivo_verificar = ''"
                        :dense="true"></v-checkbox>
                    </div>
                  </template>

                  <template slot="acciones" slot-scope="props">
                    <v-btn text icon color="red" title="Ver Log" @click="ver_log(props.row)">
                      <v-icon dark>note</v-icon>
                    </v-btn>
                  </template>


                </v-client-table>
              </v-card-text>
            </div>

          </base-material-card>
        </v-col>
      </v-row>
      <LoaderFraces ref="estadoLoader" :mensajes="lista_mensajes"></LoaderFraces>

      <v-dialog v-model="modal_faltantes" max-width="70%">
        <v-card>


          <a @click="modal_faltantes = false" small style="float: right;">
            <v-icon large>mdi-close</v-icon>
          </a>
          <v-card-title style="margin-top:-50px">

            <h3 color="primary"><b>PEDIMENTOS OMITIDOS</b></h3>
            <h4> CLAVE: <b>{{ row_selected.clave }}</b> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; AÑO:<b>{{
        row_selected.ejercicio
      }}</b> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; PERIODO:<b> {{ row_selected.periodo }}</b> </h4>

          </v-card-title>

          <v-card-text>



            <v-client-table ref="vuetable_faltantes" :data="data_faltantes" :columns="columns_faltantes"
              :options="options_faltantes" class="elevation-2 pa-2">
              <template slot="noResults">
                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
              </template>
              <template slot="fecha_operacion" slot-scope="props">
                <div v-if="props.row.fecha_operacion != null">
                  {{ props.row.fecha_operacion.substring(0, 10) }}
                </div>
                <div v-else>
                  {{ props.row.fecha_operacion }}
                </div>
              </template>
            </v-client-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>


    <v-dialog v-model="modal_verificar" max-width="40%" style=" z-index: 400 !important;" persistent>
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon class="white--text">list</v-icon>&nbsp;
            <span class="subheading">
              <strong>Verificar Periodo Omitido</strong>
            </span>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="modal_verificar = false; row_verificar.validado = !row_verificar.validado"
            class="close_modal">
            <v-icon class="white--text">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form_validar" lazy-validation>
            <span>Ingresa el motivo por el cual se realiza esta acción</span>
            <v-text-field v-model="motivo_verificar" :rules="[rules.required]"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.native="modal_verificar = false; row_verificar.validado = !row_verificar.validado">
            <v-icon>cancel</v-icon>Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.native="verificar" color="success">
            <v-icon>check</v-icon>Verificar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_log" max-width="45%" style=" z-index: 400 !important;">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon class="white--text">list</v-icon>&nbsp;
            <span class="subheading">
              <strong>Log del Registro</strong>
            </span>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="modal_log = false" class="close_modal">
            <v-icon class="white--text">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions>
          <v-card-title style="padding: 0px !important;">
            <span>{{ titulo_log }}</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <!-- <exportar-excel :data="data_detalle" :exportFields="data_detalle_excel" name="Detalle_Estados_Captura.xlsx">
                <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                    <v-icon dark>get_app</v-icon> Exportar Detalle
                </v-btn>
            </exportar-excel> -->
        </v-card-actions>
        <v-card-text>
          <v-client-table ref="vuetabledetalle" :data="datos_log" :columns="columns_log" :options="options_log"
            class="elevation-2 pa-2">
            <template slot="noResults">
              <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
            </template>
            <template slot="validado" slot-scope="props">
              <div style="display: flex; justify-content: center;">
                <v-icon v-if="!props.row.validado" color="red">close</v-icon>
                <v-icon v-else color="green">check</v-icon>
              </div>
            </template>
            <template slot="fecha" slot-scope="props">
              <div style="display: flex; justify-content: center;">
                {{ props.row.fecha.toString().substring(0, 10) }}
              </div>
            </template>
          </v-client-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="modal_log = false">
            <v-icon>cancel</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import LoaderFraces from "@/components/LoaderFraces";
import XLSX from 'xlsx';

export default {
  components: {
    LoaderFraces,
  },
  created: function () {
    this.getDestinos();

    var f_a = new Date();

    let y = f_a.getFullYear();
    let m = f_a.getMonth() + 1;
    let d = f_a.getDate();


    if (m < 10)
      m = '0' + m;
    if (d < 10)
      d = '0' + d;

    let fecha = y + "-" + m + "-" + d;
    this.model.fecha_a = fecha;
    this.model.fecha_de = y + "-01-01";

    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");


    for (let index = 2012; index <= y; index++) {
      this.ejercicios.push({ "id": index, "text": index })
    }

  },
  mounted: function () {
    this.cargar_consulta();
  },
  computed: {
    datafiltered() {

      let result = [];
      if (this.$refs.vuetable != null) {
        result = this.$refs.vuetable.allFilteredData;
        return result;
      } else {
        result = this.datos;
        return result;
      }
    },
  },
  data: () => ({
    ejercicios: [],
    destinos: [],
    periodos: [],
    datos_log: [],
    row_verificar: null,
    modal_verificar: false,
    modal_log: false,
    titulo_log: "",
    motivo_verificar: "",
    row_selected: [],
    lista_mensajes: [
      "AGRADECEMOS SU PACIENCIA..",
      "ESTAMOS PROCESANDO LOS CARGOS..",
      "VERIFICANDO IDENTIFICADORES..",
      "VALIDACIÓN DE FORMAS DE PAGO..",
      "PROCESANDO ABONOS A LA FECHA..",
      "VERIFICANDO FRACCIONES..",
      "VALIDANDO CUENTAS POR IDENTIFICADOR DE ACTIVO..",
      "ANALIZANDO SOBREDESCARGO..",
      "GESTIONANDO SALDOS POR FRACCIÓN..",
      "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..",
      "TOTALIZANDO CRÉDITO FISCAL.."
    ],
    cliente: "",
    modal_faltantes: false,
    permisoEliminar: false,
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
      text: "Inicio",
      disabled: false,
      to: "/home"
    },
    {
      text: "Auditorías",
      disabled: true,
      to: ""
    },
    {
      text: "Hallazgos en Informes",
      disabled: true,
      to: ""
    },
    {
      text: "Periodos Omitidos",
      disabled: true,
      to: ""
    }
    ],
    datos: [],

    columns: [
      "ejercicio", "periodo", "clave", "conteo_pedimentos", "conteo_descargos", "pedimentos_faltantes", "verificado", "acciones"],
    options: {
      perPage: 10,
      filterable: true,
      filterByColumn: true,

      sortable: [],
      filterable: ["ejercicio", "periodo", "clave"],
      headings: {
        "ejercicio": "Ejercicio",
        "periodo": "Periodo",
        "clave": "Destino Aduanero",
        "conteo_pedimentos": "Número Total de Operaciones / DS",
        "conteo_descargos": "Cantidad de documentos listados en TXT",
        "folio": "Número de Folio del SAT",
        "fecha_recepcion": "Fecha de Presentación",
        "fecha_validacion": "Fecha de Validación",
        "pedimentos_faltantes": "Número de Operaciones Faltantes",
        "verificado": "Verificado",
        "acciones": "Acciones"
      },
      rowClassCallback: function (row) {
        return row.conteo_descargos == 0 ? 'bgbien' : 'bgmal'
      },
    },
    columns_log: [
      "usuario", "validado", "motivo", "fecha"],
    options_log: {
      perPage: 10,
      filterable: true,
      sortable: [],
      filterable: ['usuario'],
      headings: {
        "usuario": "Usuario",
        "validado": "Verificado",
        "motivo": "Motivo",
        "fecha": "fecha",
      }
    },
    loading: false,
    show_loading: true,

    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      ejercicio: "",
      periodo: "",
      clave: ""
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    data_faltantes: [],
    columns_faltantes: ['no_pedimento', 'fecha_operacion'],
    options_faltantes: {
      headings: {

        no_pedimento: "No Pedimento",
        fecha_operacion: "Fecha Operación"
      }
    }
  }),
  methods: {
    abrir_faltantes: function (datos) {
      this.modal_faltantes = true;
      this.data_faltantes = datos;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },

    formatNumberDec: function (numero, decimales) {
      if (numero != 0 && (numero == undefined || numero == null || numero == ""))
        return "";
      numero = Number(numero);
      if (isNaN(numero)) {
        return "";
      } else
        return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    formatNumber: function (x) {
      if (x == undefined) return 0;
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },
    validaFecha: function (fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function () {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    cargar_consulta() {


      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
        "rfc": this.model.rfc,
        "usuario": this.model.usuario,
        "fecha_de": this.model.fecha_de,
        "fecha_a": this.model.fecha_a,
      };

      if (this.model.ejercicio != null && this.model.ejercicio != "") {
        data['ejercicio'] = this.model.ejercicio
      }

      if (this.model.clave != null && this.model.clave != "") {
        data['clave'] = this.model.clave
      }

      axios({
        method: "post",
        url: this.$apiSA31 + "soluciona31/reportes/rpt_proximo_periodo/",
        //url: "http://127.0.0.1:8000/soluciona31/reportes/rpt_proximo_periodo/",
        data: data
      })
        .then(response => {
          if (response.data != undefined) {
            this.datos = response.data;
          } else {
            this.datos = [];
          }
        })
        .catch(error => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al generar el reporte",
            footer: "Favor de comunicarse con soporte o intente nuevamente."
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });



    },
    exportar: function (type, fn, dl) {
      var totalp = 0;
      var totald = 0;
      var items = [];
      var items_resumen = [];
      var name = "InformesOmitidos_" + this.model.fecha_de + "_" + this.model.fecha_a + ".xlsx";

      this.datos.forEach((item) => {
        if (item['pedimentos_faltantes'] != undefined && item['pedimentos_faltantes'] != null) {
          for (var i = 0; i < item['pedimentos_faltantes'].length; i++) {
            items.push({
              "Ejercicio": item['ejercicio'],
              "Periodo": item['periodo'],
              "Destino Aduanero": item['clave'],
              "No Pedimento": item['pedimentos_faltantes'][i]['no_pedimento'],
              "Fecha Operación": (item['pedimentos_faltantes'][i]['fecha_operacion']).toString().substring(0, 10),
            })
          }
        }

        items_resumen.push({
          "Ejercicio": item['ejercicio'],
          "Periodo": item['periodo'],
          "Destino Aduanero": item['clave'],
          "Número Total de Operaciones / DS": item['conteo_pedimentos'],
          "Cantidad de Documentos Listados en TXT": item['conteo_descargos']
        });

        totalp += item['conteo_pedimentos'];
        totald += item['conteo_descargos'];
      });

      items_resumen.push({
        "Ejercicio": "Totales",
        "Periodo": "",
        "Destino Aduanero": "",
        "Número Total de Operaciones / DS": totalp,
        "Cantidad de Documentos Listados en TXT": totald
      })

      const worksheet_resumen = XLSX.utils.json_to_sheet(items_resumen);

      const worksheet = XLSX.utils.json_to_sheet(items);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet_resumen, "Resumen");
      XLSX.utils.book_append_sheet(workbook, worksheet, "Detalle");
      XLSX.writeFile(workbook, name, { compression: true });
    },
    verificar: function () {
      if (this.$refs.form_validar != undefined && !this.$refs.form_validar.validate()) {

      } else {
        this.modal_verificar = false;
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        var url = this.$apiSA31 + "soluciona31/reportes/verificar_periodo/";
        var url_test = "http://localhost:8000/soluciona31/reportes/verificar_periodo/"

        var data = this.row_verificar;
        data['usuario'] = this.$local_storage.get("nombre_usuario");
        data['rfc'] = this.$local_storage.get("rfc");
        data['motivo'] = this.motivo_verificar;

        axios({
          method: "post",
          url: url,
          data: data
        })
          .then(response => {
            this.$swal({
              type: "success",
              title: "¡Operación exitosa!",
              text: '',
              footer: '',
            });
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: '',
              footer: '',
            });
          }).then(() => {
            this.$root.$dialogLoader.hide();
            this.cargar_consulta()
          });

      }
    },
    ver_log: function (row) {
      this.datos_log = row.log.sort(function (a, b) { return new Date(b.fecha) - new Date(a.fecha); });
      this.modal_log = true;
      this.titulo_log = "Registros del <Periodo " + row.periodo + "> <Ejercicio " + row.ejercicio + "> <Clave " + row.clave + ">"
    },
    getDestinos: function () {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
        "rfc": this.$local_storage.get("rfc")
      };

      axios({
        method: "post",
        url: this.$apiSA31 + "soluciona31/reportes/get_destinos_cliente/",
        data: data
      })
        .then(response => {
          if (response.data && response.data.length) {
            this.destinos = response.data
          } else {
            this.destinos = [];
          }
        }).catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los destinos. Intente nuevamente.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

  },
};
</script>
<style scoped>
.class-center {
  text-align: center !important;
}

.class-right {
  text-align: right !important;
}

.elevation-1>>>.bgbien {
  background-color: #FCE4EC !important;
  font-weight: bold;
}

.elevation-1>>>.bgmal {
  background-color: #FFFFDD !important;
  font-weight: bold;
}
</style>
